import { render } from "./HRProfessionalProgram.vue?vue&type=template&id=0e8602b4&scoped=true&lang=html"
import script from "./HRProfessionalProgram.vue?vue&type=script&lang=js"
export * from "./HRProfessionalProgram.vue?vue&type=script&lang=js"

import "./HRProfessionalProgram.vue?vue&type=style&index=0&id=0e8602b4&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0e8602b4"

export default script